/**
 * Initialize all component namespaces.
 * */
var femcare = {};
femcare.article = {};
femcare.askExpert = {};
femcare.navigation = {};
femcare.video = { youtubeVideo: {} };
femcare.gallery = {};
femcare.share = {};
femcare.sampleCoupon = {};
femcare.general = {};
femcare.shared = {};
femcare.search = {};
femcare.product = { panel: { media: {}, info: {} } };
femcare.profile = {};
femcare.image = {};
femcare.footer = {};
femcare.tracking = {};
femcare.globalLanding = {};
femcare.ageVerification = {};
femcare.form = {};
femcare.quiz = {};
femcare.audioPlatform = {};
femcare.newsletter = {};
femcare.modal = {};
femcare.ctaPanel = {};
femcare.popupNewsletter = {};
femcare.mock = {};
